import utils from '../utils/index';
import app from '../app';

const { $html, $header, $main, $footer } = app.el;

$html.css({
  '--scrollbar-width': `${utils.getScrollbarWidth()}px`,
  '--scroll-y': `${window.scrollY}px`,
  '--vh100': `${window.innerHeight}px`,
});

window.addEventListener(
  'resize',
  utils.throttle(() => {
    $html
      .css({
        '--header-height': `${$header.height() || 0}px`,
        '--main-height': `${$main.height() || 0}px`,
        '--footer-height': `${$footer.height() || 0}px`,
      })
      .addClass('set-css-var--complete');
  }),
);
window.dispatchEvent(new Event('resize'));
